import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { SNModalService } from '@web-services/modal/snModal.service';

@Component({
	selector: 'email-reply-confirm-modal',
	template: require('./email-reply-confirm-modal.component.html'),
	styles: [require('./email-reply-confirm-modal.component.scss')]
})
export class EmailReplyConfirmModalComponent {
	@Input() btnDisabled = false;

	constructor(
		public activeModal: NgbActiveModal,
		private modalService: SNModalService
	) {}

	onSubmit(): void {
		this.modalService.setModalData({
			action: 'confirm_email_domain',
			props: true
		});
	}

	onDismiss(): void {
		this.activeModal.dismiss();
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=os2z8rc99lf!./web/modern/components/settings/email-settings-section/modals/email-reply-confirm-modal/email-reply-confirm-modal.component.ts